export default __webpack_public_path__ + "static/media/download.6a638ee2.svg";